"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const styles = (theme) => (0, styles_1.createStyles)({
    carouselContainer: {
        '& .slick-dots': {
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            width: 'unset',
            height: '25px',
            padding: '0px 16px 30px 16px',
            borderRadius: '5px',
            background: 'rgba(255, 255, 255, 0.8)'
        },
        '& .slick-dots li button': {
            width: '10px',
            height: '10px',
            padding: 0
        },
        '& .slick-dots li button::before': {
            backgroundColor: theme.palette.primary.main
        },
        '& .slick-dots li button:focus::before': {
            border: '2px solid black'
        },
        '& .slick-dots li': {
            width: '10px',
            height: '10px',
            margin: '0 10px'
        }
    }
});
exports.default = styles;
//# sourceMappingURL=EarnListStyle.js.map